import {AutocompleteControlInterface} from '../../interfaces';
import {AutocompleteGroupInterface, AutocompleteOptionInterface} from '../../components';

import {BaseControl} from './base-control';
import { Observable } from 'rxjs';

export class AutocompleteControl extends BaseControl {
    public options: AutocompleteOptionInterface[];
    public grouped: boolean;
    public async: boolean;
    public groups: AutocompleteGroupInterface[];
    public asyncOptions: (value: string) => Observable<AutocompleteOptionInterface[]>;
    public checkForEmptyInputReference: () => boolean;

    constructor(data: AutocompleteControlInterface) {
        super(data);

        this.options = data.options;
        this.grouped = data.grouped;
        this.async = data.async;
        this.asyncOptions = data.asyncOptions;
        this.groups = !data.groups ? [] : data.groups;
        this.checkForEmptyInputReference = data.checkForEmptyInputReference;
    }

    setOptions(options: AutocompleteOptionInterface[]): void {
        this.options = options;
    }
}
